import React from 'react';

import { useCurrentUser } from '../../../hooks';
import {
  create_lead_with_oauth_path,
  create_user_path,
  new_session_path,
  subscribe_one_path,
} from '../../../routes';
import { READER_URL } from '../../../src/env';
import LockedLeadCaptureForm from '../../shared/LockedLeadCaptureForm';
import MarketingLeadCaptureWithApple from '../../shared/LockedLeadCaptureForm/MarketingLeadCaptureWithApple';
import MarketingLeadCaptureWithGoogle from '../../shared/LockedLeadCaptureForm/MarketingLeadCaptureWithGoogle';

// This a react version of app/views/partials/banners/_read_this_article.html.erb
// and doesn't contain all its features
export default function GatedContent({
  emailOnly = false,
  headline,
  leadType = 'share',
  showTagline,
  tagline,
  trackingProps = {},
}: {
  emailOnly?: boolean;
  headline: string;
  leadType?: string;
  showTagline?: boolean;
  tagline?: string;
  trackingProps?: { [key: string]: string };
}) {
  const { currentUser } = useCurrentUser();
  const redirectUri = emailOnly ? window.location.href : subscribe_one_path();
  const returningUri = emailOnly ? redirectUri : `${READER_URL}${redirectUri}`;

  return (
    <div className="card p3 bordered read-this-article banner" id="read-this-article">
      <div className="row">
        <div className="col-md-12">
          <h1 className="type mb2 headline serif">{headline}</h1>
        </div>
      </div>
      {!!showTagline && (
        <div className="row tagline-container">
          <div className="col-md-12">
            <div className="mb2 tagline text-center">{tagline}</div>
          </div>
        </div>
      )}
      {/* TODO: GDPR */}
      <div className="row">
        <div className="col-md-12 action-container">
          {currentUser ? (
            <div>
              <a
                href={subscribe_one_path()}
                className="button submit-button button-blue rta-subscribe"
              >
                Subscribe
              </a>
            </div>
          ) : (
            <>
              <div className="lead-form-capture">
                <LockedLeadCaptureForm
                  formLocation="gated_content"
                  buttonText="Get Started"
                  redirectUri={redirectUri}
                  endpointUri={create_user_path()}
                  leadType={leadType}
                  forceEmailAuth={emailOnly}
                  trackingProps={trackingProps}
                />
              </div>
              <p className="type mb1 mt1">- or -</p>
              <div className="flex flex-col items-center">
                <MarketingLeadCaptureWithGoogle
                  formLocation="gated_content"
                  eventName="createLeadWithGoogle"
                  verificationUri={create_lead_with_oauth_path()}
                  leadType={leadType}
                  returningUri={returningUri}
                />
              </div>
              <div className="flex flex-col items-center mt-8">
                <MarketingLeadCaptureWithApple
                  formLocation="gated_content"
                  eventName="createLeadWithApple"
                  verificationUri={create_lead_with_oauth_path()}
                  leadType={leadType}
                  returningUri={returningUri}
                />
              </div>
            </>
          )}

          {!currentUser && (
            <p className="type mt2 mb0 quiet">
              Already a subscriber?{' '}
              <a
                href={new_session_path()}
                className="track-click quiet-link"
                data-name="login"
                data-type="link"
                data-location="email capture form"
              >
                Sign in here
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
